import queryString from 'query-string';
import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { FullPageDotLoading } from '@/components/full-page-dot-loading';
import { routes } from '@/config';
import { useJobSearchQueryByGuidQuery } from '@/graphql/generated';
import { buildSearchParams } from '@/helpers/build-search-params';

type Props = RouteComponentProps<{ guid: string }>;

export const SearchByGuidProxy: React.FC<Props> = ({ match, location: routerLocation }) => {
  const { loading, data, error } = useJobSearchQueryByGuidQuery({ variables: { guid: match.params.guid } });

  if (loading) return <FullPageDotLoading />;
  if (error || !data?.jobSearchQuery?.body) return <Redirect to={routes.search} />;

  const query = buildSearchParams(data.jobSearchQuery.body);
  const originalQueryParams = queryString.parse(routerLocation.search);
  const url = `${routes.search}?${queryString.stringify({ ...query, ...originalQueryParams })}`;

  return <Redirect to={url} />;
};
